export default "__VITE_ASSET__fc64526a__"